import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { API } from "../context/AuthContext";

const fmt = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
};

const COPY = {
  pending: "Waiting for the business to reply",
  change_requested: "The business asked for another time",
  accepted: "Accepted — finish booking to confirm",
  declined: "Declined",
  converted: "Booked",
};

/** Customer-side list of booking requests. Nothing here charges a card. */
export const MyBookingRequests = ({ authHeader }) => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");

  const load = async () => {
    try {
      const r = await axios.get(`${API}/booking-requests/customer`, { headers: authHeader() });
      setRows(r.data || []);
    } catch { /* stays empty */ }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const propose = async (r) => {
    const raw = window.prompt("New date and time (YYYY-MM-DD HH:MM, your local time):");
    if (!raw) return;
    const d = new Date(raw.replace(" ", "T"));
    if (isNaN(d.getTime())) { toast.error("That date and time isn't valid"); return; }
    setBusy(r.id);
    try {
      await axios.post(`${API}/booking-requests/${r.id}/propose`,
        { requested_at: d.toISOString() }, { headers: authHeader() });
      toast.success("Sent to the business");
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't send that time");
    } finally {
      setBusy("");
    }
  };

  if (!rows.length) return null;

  return (
    <div className="rounded-2xl border p-5" data-testid="my-booking-requests"
         style={{ borderColor: "var(--gf-border-strong)", background: "var(--gf-surface)" }}>
      <div className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--gf-text-muted)" }}>
        My booking requests
      </div>
      <div className="mt-3 space-y-3">
        {rows.slice(0, 20).map((r) => (
          <div key={r.id} className="rounded-lg border p-3" data-testid={`my-request-${r.id}`}
               style={{ borderColor: "var(--gf-border)", background: "var(--gf-bg-soft)" }}>
            <div className="text-sm" style={{ color: "var(--gf-text)" }}>
              <b>{r.service_title}</b> · {fmt(r.requested_at)}
            </div>
            <div className="text-xs mt-0.5" style={{ color: "var(--gf-text-muted)" }}>
              {r.business_name} · {COPY[r.status] || r.status}
            </div>
            {r.business_note && <div className="text-xs mt-1 italic" style={{ color: "var(--gf-text-soft)" }}>"{r.business_note}"</div>}
            <div className="mt-2 flex flex-wrap gap-2">
              {r.status === "accepted" && (
                <Link to={`/services/${r.service_id}?request_id=${r.id}`}
                      data-testid={`finish-booking-${r.id}`}
                      className="rounded-full px-4 py-1.5 text-xs font-medium"
                      style={{ background: "var(--gf-accent)", color: "var(--gf-on-accent)" }}>
                  Finish booking
                </Link>
              )}
              {r.status === "change_requested" && (
                <button type="button" data-testid={`propose-time-${r.id}`} disabled={busy === r.id}
                        onClick={() => propose(r)}
                        className="rounded-full border px-4 py-1.5 text-xs disabled:opacity-50"
                        style={{ borderColor: "var(--gf-border-strong)", color: "var(--gf-text)" }}>
                  Send another time
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyBookingRequests;
